import { twMerge } from 'tailwind-merge'
import { clsx, ClassValue } from 'clsx'

/**
 * Tailwind class concat & merge
 * @see https://www.youtube.com/watch?v=re2JFITR7TI
 */
export function cn(...classes: ClassValue[]) {
	return twMerge(clsx(classes))
}

export const debounce = (func: (...args: any[]) => any, waitFor: number) => {
	let timeout: NodeJS.Timeout

	return (...args: any[]) => {
		clearTimeout(timeout)
		timeout = setTimeout(() => func(...args), waitFor)
	}
}

/**
 * Get Tailwind grid-cols-* class
 * @param colsNumber Number of columns
 * "Don't use string concatenation to create class names" -tailwindcss.com
 */
export function getGridCols(colsNumber: number) {
	switch (colsNumber) {
		case 1:
			return 'grid-cols-1'
		case 2:
			return 'grid-cols-2'
		case 3:
			return 'grid-cols-3'
		case 4:
			return 'grid-cols-4'
		case 5:
			return 'grid-cols-5'
		case 6:
			return 'grid-cols-6'
		case 7:
			return 'grid-cols-7'
		case 8:
			return 'grid-cols-8'
		case 9:
			return 'grid-cols-9'
		case 10:
			return 'grid-cols-10'
		case 11:
			return 'grid-cols-10'
		case 12:
			return 'grid-cols-10'
		default:
			return 'grid-cols-auto'
	}
}
